import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICorporate } from 'models/corporate';
import { useTranslation } from 'react-i18next';
import { ICompany, IUser } from 'models/company';


interface Props {
  open: boolean;
  loading: boolean;
  corporate: ICorporate;
  companies: ICompany[];
  users: IUser[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditCorporate: React.FC<Props> = ({ open, loading, corporate, companies, users,
  onClose, onSubmit, onChanges }) => {
  let companiesOptions = companies.map((company) => {
    return { value: company.id, label: company.name };
  });

  let usersOptions = users.map((user) => {
    return { value: user.id, label: user.userName };
  });

  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      defaultValue: corporate.name,
      internalLabel: true,
      required: false,
      disabled: true
    },
    {
      name: 'companies',
      label: t('T_companies'),
      type: InputTypes.MULTI_SELECT,
      options: companiesOptions,
      multiple: true,
      internalLabel: true,
      required: true,
      defaultValue: companiesOptions.filter((company) => corporate.companiesIds.toLowerCase().includes(company.value.toLowerCase()))
    },
    {
      name: 'users',
      label: t('T_users'),
      type: InputTypes.MULTI_SELECT,
      options: usersOptions,
      multiple: true,
      internalLabel: true,
      required: true,
      defaultValue: usersOptions.filter((user) => corporate.usersIds.includes(user.value))
    }
  ];

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_corporate')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t("T_cancel")}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t("T_save")}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditCorporate;
